// src/hooks/useDiagnosticHydration.js
import { useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { nextAdaptiveQuestion } from "../utils/diagnostics/nextAdaptiveQuestion";

export default function useDiagnosticHydration({
  userUid,
  diagnosticId,
  definition,
  setSequence,
  setResponses,
  setCurrentQuestionId,
  setIsHydrated,
  setTimeRemaining,
}) {
  useEffect(() => {
    let mounted = true;

    async function hydrate() {
      if (!userUid || !diagnosticId || !definition) return;

      const ref = doc(
        db,
        "users",
        userUid,
        "diagnosticAttempts",
        diagnosticId
      );

      const snap = await getDoc(ref);

      const totalSeconds = definition.estimatedMinutes * 60;

      if (!snap.exists() || !mounted) {
        setSequence([]);
        setResponses({});
        setTimeRemaining(totalSeconds);
      } else {
        const data = snap.data();
        setSequence(data.sequence ?? []);
        setResponses(data.responses ?? {});

        const spent = data.totalTimeSpentSeconds ?? 0;
        const remaining = Math.max(totalSeconds - spent, 0);

        setTimeRemaining(remaining);
      }

      const sequence = snap.exists() ? snap.data().sequence ?? [] : [];
      const responses = snap.exists() ? snap.data().responses ?? {} : {};

      const nextQ = nextAdaptiveQuestion({
        definition,
        sequence,
        responses,
      });

      setCurrentQuestionId(nextQ);
      setIsHydrated(true);
    }

    hydrate();
    return () => {
      mounted = false;
    };
  }, [
    userUid,
    diagnosticId,
    definition,
    setSequence,
    setResponses,
    setCurrentQuestionId,
    setIsHydrated,
    setTimeRemaining,
  ]);
}
